var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":_vm.persistent,"width":_vm.width,"scrollable":_vm.scrollable},model:{value:(_vm.isShowDialog),callback:function ($$v) {_vm.isShowDialog=$$v},expression:"isShowDialog"}},[_c('v-card',{attrs:{"min-width":_vm.width}},[_c('v-card-title',{staticClass:"bg-color-gray py-0",style:({
        height: _vm.headerHeight + 'px',
        width: '100%',
        zIndex: 20
      })},[_c('v-layout',{staticStyle:{"margin-left":"25px"},attrs:{"row":""}},[_vm._t("dialog-title")],2),_vm._v(" "),_c('v-icon',{style:({
          right: 0 + 'px',
          top: _vm.headerHeight / 4 + 'px',
          right: _vm.headerHeight / 4 + 'px',
          zIndex: 21
        }),attrs:{"size":25},on:{"click":_vm.close}},[_vm._v("close")])],1),_vm._v(" "),_c('v-layout',{staticClass:"scroll-y",class:_vm.centered ? 'pa-4' : 'pa-0',attrs:{"column":"","align-space-around":""}},[_vm._t("dialog-content"),_vm._v(" "),_vm._t("dialog-action")],2),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-space-around":""}},[_vm._t("dialog-fix-action")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }